import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import supabase from "../supabase";
import HomeNav from "./HomeNav";
import { EyeIcon, EyeOffIcon } from "./icons/EyeIcon";
import {
  validatePassword,
  PASSWORD_REQUIREMENTS_TEXT,
} from "../lib/validatePassword";

const UpdatePassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Verify the user is actually authenticated via the email link before allowing them to see this page
  useEffect(() => {
    const checkSession = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      if (!session) {
        navigate("/login");
      }
    };
    checkSession();
  }, [navigate]);

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const passwordError = validatePassword(newPassword);
    if (passwordError) {
      setError(passwordError);
      setLoading(false);
      return;
    }

    try {
      const { error } = await supabase.auth.updateUser({
        password: newPassword,
      });

      if (error) throw error;

      alert("Password updated successfully! You can now log in.");

      // Sign them out so they can log back in with the new credentials, or navigate directly to the portal
      await supabase.auth.signOut();
      navigate("/login");
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const divStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "80px",
    paddingBottom: "80px",
    backgroundColor: "#3a886f",
    minHeight: "95vh",
  };

  return (
    <div>
      <HomeNav />
      <div style={divStyle}>
        <div className="login-container">
          <img
            className="login-logo"
            src="/Long_Black_Transparent.png"
            alt="Logo"
          />
          <h1 className="login-header">Set New Password</h1>
          {error && (
            <p style={{ color: "red", textAlign: "center" }}>{error}</p>
          )}
          <form onSubmit={handleUpdatePassword} className="login-form">
            <div
              style={{
                position: "relative",
                marginBottom: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <input
                type={showPassword ? "text" : "password"}
                placeholder="New Password (min 8 chars)"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                minLength="8"
                style={{
                  display: "block",
                  width: "100%",
                  paddingRight: "40px",
                  boxSizing: "border-box",
                  marginBottom: 0,
                }}
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? "Hide password" : "Show password"}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: 0,
                  bottom: 0,
                  margin: "auto 0",
                  height: "18px",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {showPassword ? <EyeOffIcon /> : <EyeIcon />}
              </button>
            </div>
            <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 10 }}>
              {PASSWORD_REQUIREMENTS_TEXT}
            </div>
            <button type="submit" disabled={loading}>
              {loading ? "Updating..." : "Update Password"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdatePassword;
